import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuardWithForcedLogin } from "src/app/core/auth/auth-guard-with-forced-login.service";
import { HSPAPermission } from "src/app/shared/models/hspa-permission.enum";
import { PrefixSuffixComponent } from "./prefix-suffix.component";

const routes: Routes = [
    {
      path: '',
      canActivate: [AuthGuardWithForcedLogin],
      data: { expectedPermissions: HSPAPermission.HospitalFacilitiesAccess},
      component: PrefixSuffixComponent
    }
  ];
  
  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class PrefixSuffixRoutingModule { }